module.exports = __webpack_public_path__ + "img/32_2.a6d48b11.png";